
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/pickup",
      function () {
        return require("private-next-pages/articles/pickup/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/pickup"])
      });
    }
  